import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function TestReducer(state = initialState.test, action: any) {
  switch (action.type) {
    case types.SAVE_TEST_SUCCESS:
      return action.test;
    default:
      return state;
  }
}
